import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'

import { isSoja } from '~/enums/enum'

/**
 * Schema da aba Cultivar — só os 7 campos da aba.
 *
 * As 27 características não estão no shape de propósito: quem as valida é a API.
 * Não adicionar `.noUnknown()` — ver o aviso em {@link cultivarResolver}.
 */
export const schema = yup.object({
  cultura_id: yup.string().required('Campo é obrigatório'),
  nome: yup.string().required('Campo é obrigatório'),
  genetica_id: yup.string().required('Campo é obrigatório'),
  tecnologia: yup.string().required('Campo é obrigatório'),
  grupo_maturacao: yup.string().when('cultura_id', {
    is: isSoja,
    then: yup.string().required('Campo é obrigatório'),
    otherwise: yup.string().nullable(),
  }),
  status: yup.string().required('Campo é obrigatório'),
  sts: yup.string().when('cultura_id', {
    is: isSoja,
    then: yup.string().nullable().required('Campo é obrigatório'),
    otherwise: yup.string().nullable(),
  }),
})

/**
 * Resolver da aba Cultivar.
 *
 * O payload do `onSubmit` sai do `data` que este resolver devolve, e as 27
 * características chegam nele **só porque o yup preserva chaves desconhecidas**.
 * Duas mudanças as apagariam em silêncio, sem erro de tsc:
 *
 * - `.noUnknown()` no {@link schema};
 * - `yupResolver(schema, { stripUnknown: true })` aqui.
 *
 * O teste em `__tests__/schema.test.ts` passa por este resolver justamente para
 * pegar as duas — um teste contra o `schema.validateSync` cru só pegaria a primeira.
 */
export const cultivarResolver = yupResolver(schema)
